"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.get = exports.create = exports.parseRequestOptionsFromJSON = exports.parseCreationOptionsFromJSON = void 0;
const api_1 = require("./api");
Object.defineProperty(exports, "parseCreationOptionsFromJSON", { enumerable: true, get: function () { return api_1.createRequestFromJSON; } });
Object.defineProperty(exports, "parseRequestOptionsFromJSON", { enumerable: true, get: function () { return api_1.getRequestFromJSON; } });
async function create(options) {
    const response = (await navigator.credentials.create(options));
    response.toJSON = () => (0, api_1.createResponseToJSON)(response);
    return response;
}
exports.create = create;
async function get(options) {
    const response = (await navigator.credentials.get(options));
    response.toJSON = () => (0, api_1.getResponseToJSON)(response);
    return response;
}
exports.get = get;
//# sourceMappingURL=index.js.map